import React from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';

import styles from './index.styl';

const TermsContent = ({ content }) => (
  <div styleName="rootText" dangerouslySetInnerHTML={{ __html: content }} />
);

TermsContent.propTypes = {
  content: PropTypes.node,
};

TermsContent.defaultProps = {
  content: '',
};

export default CSSModules(TermsContent, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/TermsAndConditions/TermsContent.jsx